import styled from "styled-components";

export const UiRuleSearchQuestionTypeContainer = styled.div`
	display: block;
	height: 100%;
`;
